<template lang="">
  <v-app>
      <v-container fluid>
          <v-card>

              <!--FILTRO-->
              <div class="mb-4 mt-2 pl-3 pr-3">
                  <v-row class="justify-center">      
                      <!-- FECHA INICIO -->
                      <v-col
                      cols="12"
                      md="3"
                      >
                          <v-menu v-model="fechaInicioInput" :close-on-content-click="false" 
                          :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                              <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                      v-model="fechaInicio"
                                      label="Fecha Inicio"
                                      prepend-icon="mdi-calendar"
                                      v-bind="attrs"
                                      v-on="on"
                                  ></v-text-field>
                              </template>
                                <v-date-picker locale = "es-ES" first-day-of-week="1" v-model="fechaInicio" @input="fechaInicioInput = false"></v-date-picker>
                                  </v-menu>
                                    </v-col> 
                                    <!-- FECHA FIN -->
                                    <v-col
                                    cols="12"
                                    md="2"
                                    >
                                  <v-menu v-model="fechaFinInput" :close-on-content-click="false" 
                                  :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                      <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="fechaFin"
                                  label="Fecha Fin"
                                  prepend-icon="mdi-calendar"
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker locale = "es-ES" first-day-of-week="1" v-model="fechaFin" @input="fechaFinInput = false"></v-date-picker>
                          </v-menu>
                      </v-col>
                      <v-col cols="12" md="2"> 
                          <v-text-field
                          v-model="horno"
                          label="Horno"
                          type=string
                          >
                          </v-text-field> 
                      </v-col> 
                      <v-col cols="12" md="2"> 
                          <v-text-field
                          v-model="trabajador"
                          label="Trabajador"
                          type=string
                          >
                          </v-text-field> 
                      </v-col>    
                      <v-col cols="12" md="2"> 
                          <v-text-field
                          v-model="lote"
                          label="Lote"
                          type=string
                          >
                          </v-text-field> 
                      </v-col> 
                  </v-row>  
                  <v-row>       
                      <v-col cols="12" class="text-center"> 
                          <v-btn @click="getDatosHistorico"
                          block
                          color="primary">
                              <v-icon>BUSCAR</v-icon>
                          </v-btn>
                      </v-col>
                  </v-row>
              </div>

              <!--TABLA-->
              <v-data-table
                  :loading="loading"
                  itemKey="id"
                  :headers="headers"
                  :items="datos"
                  :options="options"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
              >
                  
                  <template v-slot:[`item.dia`]="{ item }">
                      {{fecha_formateada(item.fecha_inicio).split(' ')[0]}}
                  </template>
                  
                  <template v-slot:[`item.hora`]="{ item }">
                      {{fecha_formateada(item.fecha_inicio).split(' ')[1]}}
                  </template>
                  <template v-slot:[`item.lote`]="{ item }">
                      {{!item.lote?'NO RELLENADO':item.lote}}
                  </template>
                  <template v-slot:[`item.kilos`]="{ item }">
                      {{!item.kilos?'NO RELLENADO':item.kilos}}
                  </template>
                  <template v-slot:[`item.consigna`]="{ item }">
                      {{!item.consigna?'NO RELLENADO':item.consigna}}
                  </template
                  ><template v-slot:[`item.worker`]="{ item }">
                      {{!item.worker?'NO RELLENADO':item.worker}}
                  </template>
                  <template v-slot:item.actions="{ item }">
                      <v-icon @click="showGraphicAndTable(item)">
                          mdi-finance
                      </v-icon>
                      <v-icon @click="downloadCiclo(item)">
                          mdi-download
                      </v-icon>
                  </template>

              </v-data-table>
              <!-- Apartado que se muestra cuando queremos ver un ciclo -->
              <div v-if="seeGraphic">
                  <v-row class="float-right">
                      <v-btn
                      class="float-right"
                      fab
                      x-small
                  >
                      <v-icon dark @click="closeGraphic()">
                          mdi-close
                      </v-icon>
                  </v-btn>
                  </v-row>
                  <v-row>
                      <GraficoYTablaHornos :datos="datosCiclo.datos" :ciclo="ciclo_seleccionado" />
                  </v-row>
                  
              </div>
              <!--ALERT-->
              <v-alert v-if="mensajeError" dense outlined type="error"> {{mensajeError}}</v-alert>
          </v-card>
      </v-container>
</v-app>
</template>
<script>
import GraficoYTablaHornos from "@/components/GraficoYTablaHornos.vue";
import { ExportToCsv } from "export-to-csv";
import moment from "moment-timezone";
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      sortBy: "id",
      sortDesc: true,
      ciclo_seleccionado: {},
      loading: false,
      mensajeError: "",
      trabajador: null,
      lote: null,
      horno: null,
      fechaInicio: this.getCurretDate(),
      fechaFin: this.getCurretDate(),
      fechaInicioInput: false,
      fechaFinInput: false,
      datosDesdeDíaAnterior: [],
      datos: [],
      datosCiclo: {},
      // pruebaDatos: [
      //   {
      //     id_ensayo: 2,
      //     day: "05 October 2011 14:48 UTC",
      //     lote_mp: 2,
      //     lote_bolson: 1,
      //     cuerpos_extr: 24,
      //     phase: 2,
      //     worker: "Manuel Cabezabolo",
      //     caudal_aire: 31,
      //     temperatura_tromel: 24.2,
      //     temperatura_salida: 257,
      //     date: "2020-08-12 T 00:08",
      //   },
      // ],
      seeGraphic: false,
      headers: [
        { text: "CICLO", align: "center", value: "id" },
        { text: "Horno", align: "center", value: "horno" },
        { text: "Día", align: "center", value: "dia" },
        { text: "Hora", align: "center", value: "hora" },
        { text: "Lote", align: "center", value: "lote" },
        { text: "Kilos", align: "center", value: "kilos" },
        { text: "Consigna", align: "center", value: "consigna" },
        { text: "Trabajador", align: "center", value: "worker" },
        // { text: "Resultado", align: "center", value: "ok" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      options: {
        itemsPerPage: 50,
      },
    };
  },
  methods: {
    ...mapActions(['getData']),
    fecha_formateada(f) {
      return moment(f).format("YYYY-MM-DD HH:mm:ss");
    },
    getCurretDate() {
      return new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
    },
    getDayFromDate(date) {
      return date.split(" ")[0];
    },
    getHourFromDate(date) {
      return date.split("T")[1].substring(0, 8);
    },
    async getDatosHistorico() {
      //Obtención datos para la primera tabla que muestra los distintos ciclos realizados
      this.loading = true;
      this.actualizarCiclosDesdeDíaAnterior();
      // await this.axios
      //   .get("/get-ciclos-horno", {
      //     params: {
      //       firstDay: this.fechaInicio,
      //       lastDay: this.fechaFin,
      //       lote: this.lote,
      //       horno: this.horno,
      //       worker: this.trabajador,
      //     },
      //     headers: { token: localStorage.getItem("token") },
      //   })
      const payload = {
        path: 'hornos/get-ciclos-horno',
        params: {
            firstDay: this.fechaInicio,
            lastDay: this.fechaFin,
            lote: this.lote,
            horno: this.horno,
            worker: this.trabajador,
          }
      }
      this.getData(payload)
        .then((res) => {
          if (res.ok) {
            this.mensajeError = "";
            this.datos = res.results;
            console.log(this.datos);
          } else this.mensajeError = res.message;
        })
        .catch((e) => {
          console.error(e)
          this.mensajeError = `Error ${e.response.status}. ${e.response.data.mensaje}`;
          this.datos = [];
        })
        .finally(() => {
          this.loading = false;
          this.datos.splice();
        });
    },
    async getDatosCiclo(item) {
      //Función que llamamos cuando queremos obtener todos los datos de un ciclo

      this.loading = true;
      this.datosCiclo = {}
      // await this.axios
      //   .get("/get-ciclo-horno", {
      //     params: {
      //       ciclo: item.id,
      //     },
      //     headers: { token: localStorage.getItem("token") },
      //   })
      const payload = {
        path: 'hornos/get-ciclo-horno',
        params: {
          ciclo: item.id,
        }
      } 
      await this.getData(payload)
        .then((res) => {
          if (res.ok) {
            this.mensajeError = "";
            this.datosCiclo = res.results;
            this.loading = false;
          } else this.mensajeError = res.message;
        })
        .catch((e) => {
          this.mensajeError = `Error ${e.response.status}. ${e.response.mensaje}`;
          this.datosCiclo = {};
          this.loading = false;
        });

      this.loading = false;
    },
    async showGraphicAndTable(item) {
      this.seeGraphic = false;
      this.ciclo_seleccionado = item;
      // this.ciclo_seleccionado.nombre = this.getNameFromDate(
      //   item.fechahora_ensayo
      // );
      await this.getDatosCiclo(item);
      this.seeGraphic = true;
    },
    closeGraphic() {
      this.seeGraphic = false;
    },

    async downloadCiclo(item) {
      await this.getDatosCiclo(item);
      let current_ciclo = JSON.parse(JSON.stringify(this.datosCiclo));
      console.log(current_ciclo);
      
      current_ciclo.datos = current_ciclo.datos.map(({ id,fecha, temperatura }) => ({
        id,
        id_ciclo : current_ciclo.id_ciclo,
        horno: current_ciclo.horno,
        lote: current_ciclo.lote?current_ciclo.lote:'NO RELLENADO',
        kilos: current_ciclo.kilos?current_ciclo.kilos:'NO RELLENADO',
        consigna: current_ciclo.consigna?current_ciclo.consigna:'NO RELLENADO',
        trabajador: current_ciclo.operario?current_ciclo.operario:'NO RELLENADO',
        inicio_ciclo:  moment(new Date(current_ciclo.fecha_inicio.replace(" ", "T"))).format("YYYY-MM-DD HH:mm:ss"),
        fecha : moment(new Date(fecha.replace(" ", "T"))).format("YYYY-MM-DD HH:mm:ss"),
        temperatura: temperatura.toString().replace('.',','),
      }));
   
      console.log(Object.keys(current_ciclo.datos[0]));
      //copia profunda y luego aplicar momentum
      //moment(prueba).format('YYYY-MM-DD HH:mm')

      const options = {
        fieldSeparator: ";",
        quoteStrings: '"',
        decimalSeparator: ",",
        showLabels: true,
        showTitle: false, // Sin titulo
        title: "Prueba", // Si ponemos título especificamos aquí
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: true,
        filename: `horno${this.datosCiclo.horno}_ciclo${this.datosCiclo.id_ciclo}`,
        // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
      };
      const csvExporter = new ExportToCsv(options);
      csvExporter.generateCsv(current_ciclo.datos);
    },

 

    async getDatosHistoricoConFecha(f_inicio, f_fin) {
      // this.datosDesdeDíaAnterior = await this.axios.get("/get-ciclos-horno", {
      //   params: {
      //     firstDay: f_inicio,
      //     lastDay: f_fin,
      //     horno:this.horno,
      //     // lote_mp: this.lote_mp,
      //     // worker: this.trabajador
      //   },
      //   headers: { token: localStorage.getItem("token") },
      // });
      const payload = {
        path: 'hornos/get-ciclos-horno',
        params: {
            firstDay: f_inicio,
            lastDay: f_fin,
            horno: this.horno,
            // lote_mp: this.lote_mp,
            // worker: this.trabajador
          }
      }
      this.datosDesdeDíaAnterior = await this.getData(payload);
      //console.log(this.datos)
      //console.log(this.datosDesdeDíaAnterior)
    },

    //Actualmente sin uso
    // diaAnterior(){
    //     const yesterday = new Date()
    //     console.log(yesterday)
    //     yesterday.setDate(yesterday.getDate() - 1)
    //     return this.formatDate(yesterday)
    // },

    diaAnterior2(ano, mes, dia) {
      let mes_menos_uno = parseInt(mes) - 1; //Internamente empieza desde 0
      const yesterday = new Date(ano, mes_menos_uno.toString(), dia);
      //console.log(yesterday)
      yesterday.setDate(yesterday.getDate() - 1);
      return this.formatDate(yesterday);
    },

    padTo2Digits(num) {
      return num.toString().padStart(2, "0");
    },

    formatDate(date) {
      // yyyy-mm-dd
      return [
        date.getFullYear(),
        this.padTo2Digits(date.getMonth() + 1),
        this.padTo2Digits(date.getDate()),
      ].join("-");
    },

    async actualizarCiclosDesdeDíaAnterior() {
      let ayer = this.diaAnterior2(
        this.fechaInicio.split("-")[0],
        this.fechaInicio.split("-")[1],
        this.fechaInicio.split("-")[2]
      );
      this.ciclosDesdeDiaAnterior = await this.getDatosHistoricoConFecha(
        ayer,
        this.fechaFin
      );
    },
  }, //FIN methods

  created() {
    this.getDatosHistorico();
  },
  components: {
    GraficoYTablaHornos,
  },
};
</script>